import { render, staticRenderFns } from "./v80b1030.vue?vue&type=template&id=351e35d6&"
import script from "./v80b1030.vue?vue&type=script&lang=js&"
export * from "./v80b1030.vue?vue&type=script&lang=js&"
import style0 from "./v80b1030.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports